import React from "react";
import { Row, Col } from "react-bootstrap";

const BankDetailsSection = ({ bankInfo }) => {
  return (
    <div className="bma-card">
      <div className="bma-card-body">
        <h2 className="bma-card-title mb-3">2. Bank Account Details (Registered)</h2>
        {bankInfo ? (
          <Row className="g-3" style={{ fontSize: "0.875rem", color: "#94a3b8" }}>
            <Col md={3}>
              <div className="fw-semibold">Account Holder Name</div>
              <strong style={{ color: "#ffffff" }}>{bankInfo.account_holder_name || "—"}</strong>
            </Col>
            <Col md={3}>
              <div className="fw-semibold">Account Number</div>
              <strong style={{ color: "#ffffff" }}>{bankInfo.account_number || "—"}</strong>
            </Col>
            <Col md={3}>
              <div className="fw-semibold">Bank Name</div>
              <strong style={{ color: "#ffffff" }}>{bankInfo.bank_name || "—"}</strong>
            </Col>
            <Col md={3}>
              <div className="fw-semibold">IFSC Code</div>
              <strong style={{ color: "#ffffff" }}>{bankInfo.ifsc_code || "—"}</strong>
            </Col>
          </Row>
        ) : (
          <div className="text-warning small">
            ⚠️ Bank account details not configured for this Casting Director.
          </div>
        )}
      </div>
    </div>
  );
};

export default BankDetailsSection;